import NRExportToCsvContent from './NRExportToCsvContent';
import Modal from '@mui/material/Modal';

function NRExportToCsvDialog({ isOpen = true, setIsOpen, selectAllFetchConfig, totalCount, customRouteName, specialCase }) {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="nr-export-csv-title">
      <NRExportToCsvContent
        isOpen={isOpen}
        selectAllFetchConfig={selectAllFetchConfig}
        handleClose={handleClose}
        totalCount={totalCount}
        customRouteName={customRouteName}
        specialCase={specialCase}
      />
    </Modal>
  );
}

export default NRExportToCsvDialog;
